import { tDiscountPercent } from "../../interfaces/interfaces";

export enum eUIActionTypes{
	CLEAR_STATE = 'UI/CLEAR_STATE',
	SET_IS_DEPOSIT_AVAILABLE = 'UI/SET_IS_DEPOSIT_AVAILABLE',
	SET_PROVIDER = 'UI/SET_PROVIDER',
}

export type tUIAction = 
	iClearStateAction |
	iSetIsDepositAvailableAction |
	iSetProviderAction
;

interface iClearStateAction {
	type: eUIActionTypes.CLEAR_STATE,
}

interface iSetIsDepositAvailableAction {
	type: eUIActionTypes.SET_IS_DEPOSIT_AVAILABLE,
	payload: {
		percent: tDiscountPercent,
		state: boolean,
	}
}

interface iSetProviderAction {
	type: eUIActionTypes.SET_PROVIDER,
	payload: any
}